import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\PasskeyLoginController::challenge
 * @see app/Http/Controllers/PasskeyLoginController.php:62
 * @route '/login/passkey/challenge'
 */
export const challenge = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: challenge.url(options),
    method: 'post',
})

challenge.definition = {
    methods: ["post"],
    url: '/login/passkey/challenge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PasskeyLoginController::challenge
 * @see app/Http/Controllers/PasskeyLoginController.php:62
 * @route '/login/passkey/challenge'
 */
challenge.url = (options?: RouteQueryOptions) => {
    return challenge.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasskeyLoginController::challenge
 * @see app/Http/Controllers/PasskeyLoginController.php:62
 * @route '/login/passkey/challenge'
 */
challenge.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: challenge.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\PasskeyLoginController::challenge
 * @see app/Http/Controllers/PasskeyLoginController.php:62
 * @route '/login/passkey/challenge'
 */
    const challengeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: challenge.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasskeyLoginController::challenge
 * @see app/Http/Controllers/PasskeyLoginController.php:62
 * @route '/login/passkey/challenge'
 */
        challengeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: challenge.url(options),
            method: 'post',
        })
    
    challenge.form = challengeForm
/**
* @see \App\Http\Controllers\PasskeyLoginController::verify
 * @see app/Http/Controllers/PasskeyLoginController.php:82
 * @route '/login/passkey/verify'
 */
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/login/passkey/verify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PasskeyLoginController::verify
 * @see app/Http/Controllers/PasskeyLoginController.php:82
 * @route '/login/passkey/verify'
 */
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasskeyLoginController::verify
 * @see app/Http/Controllers/PasskeyLoginController.php:82
 * @route '/login/passkey/verify'
 */
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\PasskeyLoginController::verify
 * @see app/Http/Controllers/PasskeyLoginController.php:82
 * @route '/login/passkey/verify'
 */
    const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verify.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasskeyLoginController::verify
 * @see app/Http/Controllers/PasskeyLoginController.php:82
 * @route '/login/passkey/verify'
 */
        verifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verify.url(options),
            method: 'post',
        })
    
    verify.form = verifyForm